import request from '@/config/axios';

import { AiWriteTypeEnum } from '@/views/ai/utils/constants';

export interface ModelPointRuleRespVO {
  apiKeyName: string;
  costPoint: number;
  createTime?: number;
  id?: number;
  isLimitedFree: 0 | 1;
  isMemberFree: 0 | 1;
  status: 0 | 1;
  model: string;
  name: string;
  platform: string;
  pointRuleId: number;
  type: number;
}

export interface PointRuleVo extends PageParam {
  name?: string; // 模型名字
  model?: string; //  模型标识
  platform?: string; // 平台
}

export interface PointUpdateVO {
  id: number; // 主键
  modelId?: number; // 模型id
  costPoint: number; // 消耗积分
  isMemberFree: 0 | 1; // 是否会员免费
  isLimitedFree: 0 | 1; // 是否限时免费
  status: 0 | 1; // 状态
}

export const PointruleApi = {
  getList: async (
    params: PointRuleVo
  ): Promise<PageResult<ModelPointRuleRespVO[]>> => {
    return await request.get({ url: '/ai/point-rule/page', params });
  },

  update: async (data: PointUpdateVO): Promise<ModelPointRuleRespVO> => {
    return await request.put({ url: '/ai/point-rule/update', data });
  },
  getDetail: async (id: number): Promise<ModelPointRuleRespVO> => {
    return await request.get({
      url: '/ai/point-rule/get',
      params: { id },
    });
  },
};
